import React, { useState, useEffect, useCallback } from 'react'
import { Table, Empty, Spin, Tag, Button, Modal } from 'antd'
import { ReloadOutlined } from '@ant-design/icons'
import api from '../../api'

const TYPE_COLORS = {
  '系统通知': 'blue', '审核结果': 'orange', '内容推荐': 'green',
  '账号提醒': 'purple', '活动通知': 'cyan'
}

function formatTime(val) {
  if (!val) return '-'
  const d = new Date(val)
  const pad = n => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`
}

export default function PlatformNotifyTab({ selectedAccount }) {
  const [notifies, setNotifies] = useState([])
  const [loading, setLoading] = useState(false)
  const [detailVisible, setDetailVisible] = useState(false)
  const [detailItem, setDetailItem] = useState(null)

  const loadData = useCallback(async () => {
    if (!selectedAccount?.account_id) return
    setLoading(true)
    try {
      const res = await api.getPlatformNotify({ account_id: selectedAccount.account_id })
      if (res.success) setNotifies(res.notifies || [])
      else setNotifies([])
    } catch {
      setNotifies([])
    } finally {
      setLoading(false)
    }
  }, [selectedAccount])

  useEffect(() => { loadData() }, [loadData])

  if (!selectedAccount) {
    return (
      <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Empty description="请先在左侧选择一个账号" />
      </div>
    )
  }

  const columns = [
    {
      title: '通知类型', dataIndex: 'type', key: 'type', width: 100,
      render: val => <Tag color={TYPE_COLORS[val] || 'default'}>{val}</Tag>
    },
    { title: '标题', dataIndex: 'title', key: 'title', width: 200, ellipsis: true },
    { title: '内容', dataIndex: 'content', key: 'content', ellipsis: true },
    {
      title: '时间', dataIndex: 'created_at', key: 'created_at', width: 150,
      render: val => formatTime(val)
    },
    {
      title: '状态', dataIndex: 'read', key: 'read', width: 80, align: 'center',
      render: val => val ? <span style={{ color: '#999' }}>已读</span> : <span style={{ color: '#1677ff', fontWeight: 500 }}>未读</span>
    }
  ]

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column', background: '#fff', padding: 16 }}>
      <div style={{ flexShrink: 0, marginBottom: 12, display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 12 }}>
        <span style={{ fontSize: 12, color: '#999' }}>共 {notifies.length} 条</span>
        <Button icon={<ReloadOutlined />} size="small" onClick={loadData}>刷新</Button>
      </div>

      <div style={{ flex: 1, overflow: 'auto' }}>
        <Spin spinning={loading}>
          {notifies.length > 0 ? (
            <Table
              columns={columns}
              dataSource={notifies.map((n, i) => ({ ...n, key: n.id || i }))}
              pagination={{ pageSize: 20, showSizeChanger: true, showTotal: total => `共 ${total} 条` }}
              size="small"
              scroll={{ x: 700 }}
              onRow={(record) => ({
                style: { cursor: 'pointer' },
                onClick: () => { setDetailItem(record); setDetailVisible(true) }
              })}
            />
          ) : (
            !loading && <Empty description="暂无平台通知" style={{ marginTop: 60 }} />
          )}
        </Spin>
      </div>

      <Modal
        title={detailItem?.title || '通知详情'}
        open={detailVisible}
        onCancel={() => { setDetailVisible(false); setDetailItem(null) }}
        footer={null}
        width={520}
      >
        {detailItem && (
          <div>
            <p style={{ display: 'flex', gap: 12, marginBottom: 12 }}>
              <Tag color={TYPE_COLORS[detailItem.type] || 'default'}>{detailItem.type}</Tag>
              <span style={{ color: '#999' }}>{formatTime(detailItem.created_at)}</span>
            </p>
            <p style={{ fontSize: 14, lineHeight: 1.8 }}>{detailItem.content}</p>
          </div>
        )}
      </Modal>
    </div>
  )
}
